import { render, staticRenderFns } from "./currencyForm.vue?vue&type=template&id=38388304&"
import script from "./currencyForm.vue?vue&type=script&lang=js&"
export * from "./currencyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports